<template>
  <div class="container zeropadding">
    <div class="row">
      <div class="col-4 padding1" v-for="t in sorted_teams" :key="t.id">
        <div
          class="card mb-1 border border-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          @click="store.setViewerExpandTeamId(t.id, 'team')"
        >
          <div class="card-body padding1">
            <div class="row">
              <div class="col">
                <LogoSmall :path="t.icon"></LogoSmall>
              </div>
            </div>
            <!-- <div class="fw-bold smalltxt">{{ t.name }}</div> -->
            <ul class="list-group border">
              <li
                class="list-group-item padding1 smalltxt bg-grad-grey border-0 fw-bold"
                v-for="n in splitLastWord(t.name)"
                :key="n"
              >
                {{ n }}
              </li>
            </ul>
            <div class="card-text">
              <div
                class="row g-0 d-flex align-items-center justify-content-center border rounded"
              >
                <div class="col-9 smalltxt text-center text-success fw-bold">
                  {{ formatToIndianCurrency(t.wallet) }}
                </div>
                <div class="col-3 smalltxt text-center text-primary">
                  {{ totalPlayers(t.id) }}
                </div>
              </div>
              <div
                class="row g-0 text-muted midtxt d-flex align-items-center border rounded"
                v-for="p in sorted_pools"
                :key="p"
              >
                <div class="col-9 text-start p-1">{{ p.name }}</div>
                <div class="col-3 text-primary">
                  {{ purchasedPlayers(t.id, p.id) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import supabase from "@/supabase/config";
import { onMounted, ref, computed } from "vue";
import { useStore } from "@/store/index";
import LogoSmall from "../../bidder/logos/LogoSmall.vue";
const store = useStore();
const all_teams = ref([]);
const all_pools = ref([]);
const all_players = ref([]);
function splitLastWord(str) {
  const trimmed = str.trim();
  const lastSpace = trimmed.lastIndexOf(" ");

  if (lastSpace === -1) {
    return [trimmed, "\u00A0"]; // Only one word, use non-breaking space
  }

  return [trimmed.substring(0, lastSpace), trimmed.substring(lastSpace + 1)];
}
onMounted(() => {
  setTimeout(() => {
    fetchTeams();
    fetchPools();
    fetchPlayers();
  }, 1000);
});
const fetchPlayers = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_players.value = players;
  setupPlayersListner();
};
const setupPlayersListner = () => {
  const channels = supabase
    .channel("players-viewer-iio32f-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "players" },
      (payload) => {
        // console.log("Change received!", payload);
        const index = all_players.value.findIndex(
          (obj) => obj.id === payload.new.id
        );
        if (index) {
          all_players.value.splice(index, 1);
          all_players.value.push(payload.new);
        }
      }
    )
    .subscribe();
};
const fetchTeams = async () => {
  let { data: teams, error } = await supabase
    .from("teams")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_teams.value = teams;
  setupTeamsListner();
};
const setupTeamsListner = () => {
  const channels = supabase
    .channel("viewer-teams-kkjk2-custom-update-channel")
    .on(
      "postgres_changes",
      { event: "UPDATE", schema: "public", table: "teams" },
      (payload) => {
        //console.log("Change received!", payload);
        const index = all_teams.value.findIndex(
          (obj) => obj.id === payload.new.id
        );
        if (index) {
          all_teams.value.splice(index, 1);
          all_teams.value.push(payload.new);
        }
      }
    )
    .subscribe();
};
const fetchPools = async () => {
  let { data: pools, error } = await supabase
    .from("pools")
    .select("*")
    .eq("auction_id", store.live_auction);
  all_pools.value = pools;
};
const sorted_teams = computed(() => {
  var arr = [];
  all_teams.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  //sorted_arr = [...arr].sort((a, b) => b.wallet - a.wallet);
  sorted_arr = [...arr].sort((a, b) => a.name.localeCompare(b.name));
  return sorted_arr;
});
const sorted_pools = computed(() => {
  var arr = [];
  all_pools.value.forEach((p) => {
    arr.push(p);
  });
  var sorted_arr = [];
  sorted_arr = [...arr].sort((a, b) => a.sort - b.sort);
  return sorted_arr;
});
const purchasedPlayers = (team_id, pool_id) => {
  var count = 0;
  all_players.value.forEach((p) => {
    if (p.team_id == team_id && p.pool_id == pool_id) {
      count++;
    }
  });
  return count;
};
function formatToIndianCurrency(num) {
  if (num) return num.toLocaleString("en-IN");
}
const totalPlayers = (team_id) => {
  var count = 0;
  all_players.value.forEach((p) => {
    if (p.team_id == team_id) {
      count++;
    }
  });
  return count;
};
</script>
<style scoped>
.padding1 {
  padding: 1px;
}
.midtxt {
  font-size: 10px;
}
.smalltxt {
  font-size: 12px;
}
.zeropadding {
  padding: 0px;
}
</style>
